export default {
    withCapitalLetter(word){
        return word.trim() ? 
                word.substring(0, 1).toUpperCase() + word.substring(1, word.length)
                : word;
    }
};